'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var validityKeys = ['badInput', 'customError', 'patternMismatch', 'rangeOverflow', 'rangeUnderflow', 'stepMismatch', 'tooLong', 'tooShort', 'typeMismatch', 'valueMissing'];

exports.default = validityKeys;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/constants/validity-keys.js
// module id = 1302
// module chunks = 0